// Member-facing stage names (internal phase keys stay unchanged in the API)
export const PHASE_LABEL = { RESET: "ESTABLISH", ESTABLISH: "PROGRESS", PROGRESS: "PROGRESS HARDER", "OWN IT": "OWN IT" };
export const phaseLabel = (p) => PHASE_LABEL[p] || p;
